import api from './api';

export interface OnboardingChecklist {
  createdAgent: boolean;
  ranAgent: boolean;
  activated: boolean;
}

export interface ActivationFunnel {
  signedUp: number;
  createdAgent: number;
  ranAgent: number;
  activated: number;
  medianTimeToActivateHours: number | null;
  repeatRate: number;
}

export interface StarterAgentResult {
  agentId: string;
  executionId: string;
}

export interface GrowthScorecard {
  totalUsers: number;
  activatedUsers: number;
  activationRate: number;
  payingSubscribers: number;
  trialingSubscribers: number;
  compedUsers: number;
  estimatedMrrUsd: number;
  medianTimeToActivateHours: number | null;
  repeatRate: number;
}

export const onboardingService = {
  /** The current user's first-run activation checklist. */
  async get(): Promise<OnboardingChecklist> {
    const res = await api.get<OnboardingChecklist>('/onboarding');
    return res.data;
  },
  /** Platform activation funnel (admin only). */
  async getFunnel(): Promise<ActivationFunnel> {
    const res = await api.get<ActivationFunnel>('/admin/funnel');
    return res.data;
  },
  /** Growth scorecard KPIs (admin only). */
  async getGrowth(): Promise<GrowthScorecard> {
    const res = await api.get<GrowthScorecard>('/admin/growth');
    return res.data;
  },
  /** One-click: create a ready-to-run starter agent and run it. */
  async createStarter(): Promise<StarterAgentResult> {
    const res = await api.post<StarterAgentResult>('/onboarding/starter-agent');
    return res.data;
  },
};
